import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackClickRemoveFromFolder } from './tracking';
import { RemoveFavorite } from '../../components/RemoveFavorite';
import { selectSelectedFolder } from '../../selectors/folders';
import { selectResults } from '../../selectors/results';
import { removeByIds } from '../../thunk/favorites';
import { EDealType, EEntityType } from '../../types/filters';
import { isHideModalConfirmRemoveFromFavorites } from '../../utils/remove';
import { ModalConfirmRemoveContainer } from '../MassActions/remove/ModalConfirmRemoveContainer';
import { ModalConfirmRemoveFromFolderContainer } from '../MassActions/remove/ModalConfirmRemoveFromFolderContainer';

interface IRemoveFavoriteContainerProps {
  dealType: EDealType;
  entityId: number;
  favoriteEntityType: EEntityType;
}

export function RemoveFavoriteContainer({ dealType, entityId, favoriteEntityType }: IRemoveFavoriteContainerProps) {
  const [isConfirmModalVisible, setConfirmModalVisible] = React.useState(false);
  const { removeFavorite, favoriteEntities } = useSelector(selectResults);
  const selectedFolder = useSelector(selectSelectedFolder);
  const dispatch = useDispatch();

  const handleClose = () => {
    setConfirmModalVisible(false);
  };

  const handleClick = () => {
    trackClickRemoveFromFolder(entityId, favoriteEntities);
    if (!isHideModalConfirmRemoveFromFavorites()) {
      setConfirmModalVisible(true);
    } else {
      dispatch(removeByIds(entityId));
    }
  };

  let modal;
  if (selectedFolder) {
    modal = <ModalConfirmRemoveFromFolderContainer entityId={entityId} onClose={handleClose} />;
  } else {
    modal = <ModalConfirmRemoveContainer entityId={entityId} onClose={handleClose} />;
  }

  return (
    <>
      {isConfirmModalVisible && modal}
      <RemoveFavorite
        removeFavoriteState={removeFavorite}
        entityId={entityId}
        favoriteEntityType={favoriteEntityType}
        dealType={dealType}
        onClick={handleClick}
      />
    </>
  );
}
